import React from "react";
class FullWidthImage extends React.Component {


    render() {
        let quotation;
        const focalPointX = this.props.focalPoint['x'] * 100;
        const focalPointY = this.props.focalPoint['y'] * 100;
        if (this.props.quotation) {
            quotation =    <div className={"rob-fullWidthImage__title"}>
                            <h1>
                                {this.props.quotation}
                            </h1>
                        </div>;
        } else {
            quotation = '';
        }
        return (
          <section className="rob-fullWidthImage" style={{backgroundImage: `url(${this.props.image})`, backgroundPosition: `${focalPointX}% ${focalPointY}%`  }}>
              {quotation}
          </section>
        )
    }

}


export default FullWidthImage;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/FullWidthImage.js